import moment from "moment";

const AnnualPlanner = (app) => {
  app.post(
    "/annual-planner/add-calendar-event",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      !body.event_to && delete body.event_to;
      try {
        await api(`calendar-event`, {
          method: "POST",
          body,
        });

        flash("success", `Successfully added`);

        res.refreshWith(
          {
            "modal[type]": "",
            eventTo: "",
            eventFrom: "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);

        res.refreshWith(
          {
            "modal[type]": "add-event",
            date: body.modalParams?.date,
            athlete: body.modalParams?.athlete,
            eventTo: "",
            eventFrom: "",
          },
          { url: body.modalUrl, hash: "#_" }
        );
      }
    }
  );
  app.post(
    "/annual-planner/update-calendar-event",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      try {
        await api(`calendar-event`, {
          method: "PUT",
          body,
        });

        flash("success", `Successfully updated`);

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({ url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/remove-calendar-event",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { athleteId, eventId, organizationCoachId = undefined } = body;

      let url = `calendar-event?athleteId=${athleteId}&eventId=${eventId}`;

      if (organizationCoachId) {
        url = `calendar-event?athleteId=${athleteId}&eventId=${eventId}&organizationCoachId=${organizationCoachId}`;
      }

      delete body.organizationCoachId;

      try {
        await api(url, {
          method: "DELETE",
          body,
        });

        flash("success", `Successfully removed`);

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({ url: "back", hash: "#_" });
      }
    }
  );
  app.post(
    "/annual-planner/phase-template",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { organizationOwner } = locals;

      body.organizationOwnerId = organizationOwner?._id;

      try {
        await api(`coach-phase-template`, {
          method: "POST",
          body,
        });

        flash("success", `Successfully added`);

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
  app.post(
    "/annual-planner/update-phase-template",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { organizationOwner } = locals;

      body.organizationOwnerId = organizationOwner?._id;

      try {
        await api(`coach-phase-template`, {
          method: "PUT",
          body,
        });

        flash("success", `Successfully updated`);

        res.refreshWith(
          {
            "modal[type]": "phase-templates",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
  app.post(
    "/annual-planner/remove-phase-template",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { organizationOwner } = locals;

      const organizationCoachId = body.organizationCoachId || undefined;
      const organizationOwnerId = organizationOwner?._id;

      // in case the props are undefined they just wont arrive to the api
      let url = `coach-phase-template?templateId=${body.templateId}&organizationCoachId=${organizationCoachId}&organizationOwnerId=${organizationOwnerId}`;

      delete body.organizationCoachId;

      try {
        await api(url, {
          method: "DELETE",
          body,
        });

        flash("success", `Successfully deleted`);

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/remove-default-template",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { organizationOwner } = locals;
      const organizationOwnerId = organizationOwner?._id;

      // in case the props are undefined they just wont arrive to the api
      let url = `coach-phase-template?removeDefault=${body.removeDefault}&organizationCoachId=${body.organizationCoachId}&organizationOwnerId=${organizationOwnerId}`;

      delete body.organizationCoachId;

      try {
        await api(url, {
          method: "DELETE",
          body,
        });

        flash("success", `Successfully removed`);

        res.refreshWith(
          {
            "modal[type]": "phase-templates",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/set-athlete-phases",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      const { organizationOwner } = locals;

      const organizationOwnerId = organizationOwner?._id;
      organizationOwnerId && (body.organizationOwnerId = organizationOwnerId);

      try {
        await api(`athlete-phases`, {
          method: "POST",
          body,
        });

        body.onlySetDefault
          ? flash("success", `Successfully set as default`)
          : flash("success", `Phases successfully set`);

        res.refreshWith(
          {
            "modal[type]": "",
            changedTemplate: true,
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
  app.post(
    "/annual-planner/update-athlete-phase",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      try {
        await api(`athlete-phases`, {
          method: "PUT",
          body,
        });

        flash("success", `Successfully updated`);

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/remove-athlete-phase",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      const { athleteId, phaseName, organizationCoachId = undefined } = body;
      const { organizationOwner } = locals;
      const organizationOwnerId = organizationOwner?._id;

      // in case the props are undefined they just wont arrive to the api
      let url = `athlete-phases?athleteId=${athleteId}&phaseName=${phaseName}&organizationCoachId=${organizationCoachId}&organizationOwnerId=${organizationOwnerId}`;

      delete body.organizationCoachId;

      try {
        await api(url, {
          method: "DELETE",
          body,
        }).then((res) => {
          if (res.status === 200) flash("success", `Successfully removed`);
          else flash("error", res.statusText || "Error removing phase.");
        });

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
  // * COMPLETED
  app.post(
    "/annual-planner/set-athlete-phase-attachment",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      const { organizationOwner } = locals;
      const organizationOwnerId = organizationOwner?._id;

      organizationOwnerId && (body.organizationOwnerId = organizationOwnerId);

      try {
        const response = await api(`athlete-phases-attachments`, {
          method: "POST",
          body,
        });

        res.refreshWith(
          {
            athleteSwitch: false,
            changedTemplate: false,
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/set-athlete-phase-description",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      const { organizationOwner } = locals;
      const organizationOwnerId = organizationOwner?._id;

      organizationOwnerId && (body.organizationOwnerId = organizationOwnerId);

      try {
        await api(`athlete-phases-descriptions-attachments`, {
          method: "POST",
          body,
        });

        flash("success", `Successfully added`);

        return res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        return res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/update-athlete-phase-description",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      try {
        const response = await (
          await api(`athlete-phases-descriptions-attachments`, {
            method: "PUT",
            body,
          })
        ).json();

        const {
          newPhaseDescription: { phaseDescription, dateAttachment },
        } = response;

        flash("success", `Successfully updated`);

        return res.refreshWith(
          {
            "modal[type]": "",
            phaseDescription,
            weekFirstDay: moment(dateAttachment, "YYYYMMDD").format(
              "MMM D, YYYY"
            ),
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        return res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/remove-athlete-phase-description",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      const {
        dateAttachment,
        athleteId,
        organizationCoachId = undefined,
      } = body;

      let url = `athlete-phases-descriptions-attachments?dateAttachment=${dateAttachment}&athleteId=${athleteId}`;

      if (organizationCoachId) {
        url = `athlete-phases-descriptions-attachments?dateAttachment=${dateAttachment}&athleteId=${athleteId}&organizationCoachId=${organizationCoachId}`;
      }

      delete body.organizationCoachId;

      try {
        await api(url, {
          method: "DELETE",
        });

        flash("success", `Successfully removed`);

        return res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        return res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
};

export default AnnualPlanner;
